import { useEffect, useRef, useState } from 'react'

import {
  Navbar,
  NavbarItem,
  NavbarSection,
  NavbarSpacer,
} from '@/components/base/navbar'
import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarHeader,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
  SidebarSpacer,
} from '@/components/base/sidebar'
import { SidebarLayout } from '@/components/base/sidebar-layout'
import {
  CalendarIcon,
  LightBulbIcon,
  ClipboardIcon,
  CurrencyPoundIcon,
  DocumentIcon,
  // GlobeAltIcon,
  HomeIcon,
  InboxIcon,
  MagnifyingGlassIcon,
  QuestionMarkCircleIcon,
  SparklesIcon,
  UsersIcon,
  GlobeAltIcon,
} from '@heroicons/react/24/solid'
import { ProfileDropdown } from '@/components/layout/profile_dropdown'
import { CompaniesDropdown } from '@/components/layout/companies_dropdown'
import { Outlet, useNavigation } from 'react-router'
import { GridLoader } from 'react-spinners'
import { SupportDialog } from '@/components/support/dialog'
import { ChangelogDialog } from '@/components/changelog/dialog'

export const Layout = () => {
  const [showLoading, setShowLoading] = useState(false)
  const [showSupport, setShowSupport] = useState(false)
  const [showChangelog, setShowChangelog] = useState(false)
  const navigation = useNavigation()

  const loadingTimer = useRef<NodeJS.Timeout>(null)

  useEffect(() => {
    if (navigation.state === 'loading') {
      loadingTimer.current = setTimeout(() => { setShowLoading(true) }, 500)
    } else {
      if (loadingTimer.current) clearTimeout(loadingTimer.current)
    }
  }, [navigation.state])

  return (
    <SidebarLayout
      navbar={
        <Navbar>
          <NavbarSpacer />
          <NavbarSection>
            <NavbarItem aria-label="Search" href="/search">
              <MagnifyingGlassIcon />
            </NavbarItem>
            <NavbarItem aria-label="Inbox" href="/inbox">
              <InboxIcon />
            </NavbarItem>
            <ProfileDropdown position="navbar" />
          </NavbarSection>
        </Navbar>
      }
      sidebar={
        <Sidebar>
          <SidebarHeader>
            <CompaniesDropdown />
            {/* <SidebarSection className="max-lg:hidden">
              <SidebarItem href="/inbox">
                <InboxIcon />
                <SidebarLabel>Inbox</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/search">
                <MagnifyingGlassIcon />
                <SidebarLabel>Search</SidebarLabel>
              </SidebarItem>
            </SidebarSection> */}
          </SidebarHeader>
          <SidebarBody>
            <SidebarSection>
              <SidebarItem href="/">
                <HomeIcon />
                <SidebarLabel>Home</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/events">
                <CalendarIcon />
                <SidebarLabel>Events</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/clients">
                <UsersIcon />
                <SidebarLabel>Clients</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/documents">
                <DocumentIcon />
                <SidebarLabel>Documents</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/asset-types">
                <LightBulbIcon />
                <SidebarLabel>Equipment</SidebarLabel>
              </SidebarItem>
              <SidebarItem href="/maintenance">
                <ClipboardIcon />
                <SidebarLabel>Maintenance</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSection>
              <SidebarItem href="/portfolio">
                <GlobeAltIcon />
                <SidebarLabel>Website</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
            <SidebarSpacer />
            <SidebarSection>
              <SidebarItem href={import.meta.env.VITE_RIPPLE_STRIPE_PORTAL_URL}>
                <CurrencyPoundIcon />
                <SidebarLabel>Billing</SidebarLabel>
              </SidebarItem>
              <SidebarItem onClick={() => setShowSupport(true)}>
                <QuestionMarkCircleIcon />
                <SidebarLabel>Support</SidebarLabel>
              </SidebarItem>
              <SidebarItem onClick={() => setShowChangelog(true)}>
                <SparklesIcon />
                <SidebarLabel>What's new</SidebarLabel>
              </SidebarItem>
            </SidebarSection>
          </SidebarBody>
          <SidebarFooter className="max-lg:hidden">
            <ProfileDropdown position="sidebar" />
          </SidebarFooter>
        </Sidebar>
      }
    >
      <Outlet />
      <div className={`transition duration-500 fixed bottom-12 right-12 ${showLoading ? 'opacity-100' : 'opacity-0'}`}>
        <div className="w-full flex flex-row justify-center">
          <GridLoader color="lightgray" size={12} />
        </div>
      </div>
      <SupportDialog open={showSupport} setOpen={setShowSupport} />
      <ChangelogDialog open={showChangelog} setOpen={setShowChangelog} />
    </SidebarLayout>
  )
}
